var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAttachment(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.5,12l-7.8-7.8c-.4-.4-1-.4-1.4,0s-.4,1,0,1.4l4.1,4.1,3.7,3.7c1.6,1.6,1.6,4.1,0,5.7-1.6,1.6-4.1,1.6-5.7,0l-3.7-3.7-2.6-2.6-3.3-3.3c-1-1-1-2.6,0-3.5s2.6-1,3.5,0l1.3,1.3,1.3,1.3,4.5,4.5,2.4,2.4c.4.4.4,1,0,1.4s-1,.4-1.4,0l-2.4-2.4-5.4-5.4c-.4-.4-1-.4-1.4,0s-.4,1,0,1.4l7.8,7.8c1.2,1.2,3.1,1.2,4.2,0s1.2-3.1,0-4.2L8.5,4.2h0c-1.8-1.4-4.4-1.3-6,.4s-1.7,4.2-.3,6h0s9.9,9.9,9.9,9.9c2.3,2.3,6.1,2.3,8.5,0s2.3-6.1,0-8.5Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAttachment);
export default __webpack_public_path__ + "static/media/attachment.1bfa694a58297247fb82bf2444ef2586.svg";
export { ForwardRef as ReactComponent };